module.exports = __webpack_public_path__ + "img/coin_10.4745d1b8.png";